export default __webpack_public_path__ + "static/media/bids.67e003df.jpg";